import VSelectStudent from './index.vue';

export default {
  install: (Vue) => Vue.component('VSelectStudent', VSelectStudent),
};
